<template>
  <div class="blacklistReport pb10">
    <div class="fc-less padding7">“不诚信”人员基本信息</div>
    <div class="blacklistReport-form pl7 pr7">
      <van-form ref="uForm" validate-trigger="onChange">
        <van-cell-group inset v-for="(cell, cellindex) in reportedFieldList" :key="cell.field" :label="cell.title" :prop="cell.field" :borderBottom="cellindex+1 !== reportedFieldList.length">
          <van-field :label="cell.title" :name="cell.field" :rules="rules[cell.field]?[rules[cell.field]]:[]">
            <template #input>
              <template v-if="isEdit">
                <div v-if="cell.field === 'infoPic'" class="col text-right">
                  <van-uploader
                    name="4"
                    uploadText="点此上传资料"
                    multiple
                    :fileList="userInfo[cell.field]"
                    :previewFullImage="true"
                    :after-read="afterRead"
                    @delete="deletePic"
                    :max-count="99"
                  ></van-uploader>
                </div>
                <template v-else>
                  <div v-if="cell.field === 'informantPhoneNumber'" class="row align-items-center text-right">
                    <span class="flex-1">{{userInfo[cell.field]}}</span>
                  </div>
                  <input v-else
                    class="custom-input"
                    v-model="userInfo[cell.field]"
                    :type="cell.field==='name'?'name':''"
                    :placeholder="`在这里填写${cell.title}`"
                    :name="cell.field"
                    @input="changeInput"
                  />
                </template>
              </template>
              <template v-else>
                <div v-if="cell.field === 'infoPic'" class="col text-right">
                  <van-uploader
                    multiple
                    :fileList="userInfo[cell.field]"
                    :previewFullImage="true"
                    :deletable="false"
                    :show-upload="false"
                  ></van-uploader>
                </div>
                <div v-else class="col text-right">
                  {{ userInfo[cell.field] }}
                </div>
              </template>
            </template>
          </van-field>
        </van-cell-group>
      </van-form>
    </div>
    <template v-if="isEdit">
      <div class="fc-less padding7">留下您的联系方式，以便工作人员及时和您获得联系并对您提供的相关材料进行复核</div>
      <div class="blacklistReport-form pl7 pr7">
        <van-form ref="uFormReporter" validate-trigger="onChange">
          <van-cell-group v-for="(cell, cellindex) in submitterFieldList" :key="cell.field" :label="cell.title" :prop="cell.field" :borderBottom="cellindex+1 !== reportedFieldList.length">
            <van-field :label="cell.title" :name="cell.field" :rules="rules[cell.field]?[rules[cell.field]]:[]">
              <template #input>
                <template v-if="isEdit">
                  <div v-if="cell.field === 'phoneNumber'" class="row align-items-center text-right">
                    <span class="flex-1">{{userInfo[cell.field]}}</span>
                    <!-- <div class="pl3">
                      <van-button size="small" type="primary" plain class="custom-button" text="换一个" open-type="getPhoneNumber" @getphonenumber="getPhoneNumber"></van-button>
                    </div> -->
                  </div>
                  <input v-else
                    class="custom-input"
                    v-model="userInfo[cell.field]"
                    :type="cell.field==='name'?'name':''"
                    :placeholder="`在这里填写${cell.title}`"
                    :name="cell.field"
                    @input="changeInput"
                  />
                </template>
                <div v-else class="col text-right">
                  {{ userInfo[cell.field] }}
                </div>
              </template>
            </van-field>
          </van-cell-group>
        </van-form>
      </div>
      <div class="mt10 pl7 pr7 text-center">
        <van-button round block type="info" @click="submit">
          提交
        </van-button>
      </div>
    </template>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  sendRequest, uploadFile, addBlack, upload, saveBlack,
} from '@/network/NetworkAccessor';
import config from '@/config';
import storage from '@/uitls/cacheUtil';

const tagTypes = ['warning', 'success', 'error', 'info'];
export default Vue.extend({
  data() {
    return {
      FILE_DOMAIN: config.FILE_DOMAIN,
      actionShow: false,
      tipShow: false,
      time: +new Date(),
      tagTypes,
      userInfo: {
        name: '',
        gender: '',
        address: '',
        wxNumber: '',
        phoneNumber: '',
        idNumber: '',
        infoPic: [],
        informantName: '',
        informantWechatNo: '',
        informantPhoneNumber: '',
      },
      identityList: [],
      // customStyle: {
      // },
      reportedFieldList: [
        {
          field: 'name',
          icon: '',
          title: '姓名',
        },
        {
          field: 'gender',
          icon: '',
          title: '性别',
        },
        {
          field: 'address',
          icon: '',
          title: '籍贯',
        },
        {
          field: 'phoneNumber',
          icon: '',
          title: '手机号',
        },
        {
          field: 'wxNumber',
          icon: '',
          title: '微信号',
        },
        {
          field: 'idNumber',
          icon: '',
          title: '身份证号',
        },
        {
          field: 'infoPic',
          icon: '',
          title: '资料证据',
        },
        {
          field: 'remark',
          icon: '',
          title: '备注',
        },
      ],
      submitterFieldList: [
        {
          field: 'informantName',
          icon: '',
          title: '举报人姓名',
        },
        {
          field: 'informantPhoneNumber',
          icon: '',
          title: '举报人手机号',
        },
        {
          field: 'informantWechatNo',
          icon: '',
          title: '举报人微信号',
        },
      ],
      regionShow: false,
      selectRegion: {
        province: {},
        city: {},
        area: {},
      },
      selectRegionIndex: [],
      regions: [],
      rules: {
        name: {
          message: '请完善“不诚信人员”姓名',
          validator: (value) => {
            console.log('value------', value, '~', this.userInfo.name);

            return !!((this.userInfo.name || '').trim());
          },
        },
        informantName: {
          message: '请完善举报人的信息',
          validator: value => !!((this.userInfo.informantName || '').trim()),
        },
        informantPhoneNumber: {
          message: '请完善举报人的手机号',
          validator: value => !!((this.userInfo.informantPhoneNumber || '').trim()),
        },
        infoPic: {
          message: '请补充资料证据',
          validator: (value) => {
            const { infoPic = [] } = this.userInfo;
            console.log('-----infoPic----', infoPic);
            return !!(infoPic && infoPic.filter(item => item.status !== 'failed').length);
          },
        },
      },
    };
  },
  created() {
    const { infoPic = [], ...detail } = storage.session.get('BLACK_ITEM') || {};
    this.userInfo = {
      ...this.userInfo,
      ...detail,
      infoPic: infoPic.map((url => ({
        url: `${this.FILE_DOMAIN}${url}`,
      }))),
    };
    console.log(detail, this.userInfo);
  },
  computed: {
    isEdit() {
      return this.$route.name === 'BlackListEdit';
    },
  },
  methods: {
    // 删除图片
    deletePic(file) {
      // this[`fileList${event.name}`].splice(event.index, 1);
      const { infoPic = [] } = this.userInfo;
      // console.log(file, [...infoPic]);
      const findindex = infoPic.findIndex(item => (item.url && item.url === file.url) || item.content === file.content);
      infoPic.splice(findindex, 1);
      this.$set(this.userInfo, 'infoPic', infoPic);
    },
    // 新增图片
    async afterRead(files) {
      let tfiles = [files];
      if (Array.isArray(files)) {
        tfiles = files;
      }
      const lists = [].concat(tfiles);
      const { infoPic = [] } = this.userInfo;
      let fileListLen = infoPic.length;
      lists.forEach((item) => {
        infoPic.push({
          ...item,
          status: 'uploading',
          message: '上传中',
        });
      });
      for (let i = 0; i < lists.length; i += 1) {
        const item = { ...infoPic[fileListLen] };
        try {
          // eslint-disable-next-line no-await-in-loop
          const result = await this.uploadFilePromise(lists[i].file);
          // console.log(result);
          infoPic.splice(fileListLen, 1, Object.assign(item, {
            status: 'success',
            message: '',
            url: result,
          }));
        } catch (error) {
          infoPic.splice(fileListLen, 1, Object.assign(item, {
            status: 'failed',
            message: error && error.message ? error.message : '上传失败',
          }));
        }
        fileListLen += 1;
      }
    },
    uploadFilePromise(file) {
      // console.log(file);
      const params = new FormData();
      params.append('file', file);
      return upload(uploadFile, params);
    },
    changeInput(e) {
      const { target } = e || {};
      // console.log('changeInput-----', e);
      const field = target.name;
      // this.$set(this.userInfo, 'name', e.detail.value);
      Promise.all([
        this.$refs.uForm.validate([field]),
        this.$refs.uFormReporter.validate([field]),
      ]);
    },
    save() {
      const { infoPic = [], ...params } = this.userInfo;
      sendRequest(params.id ? saveBlack : addBlack, {
        ...params,
        infoPic: infoPic.filter(info => info.status !== 'failed' && info.url).map((info) => {
          if (info.url.indexOf(this.FILE_DOMAIN) === 0) {
            return info.url.replace(this.FILE_DOMAIN, '');
          }
          return info.url;
        }),
      }).then((res) => {
        this.$dialog.alert({
          message: '信息提交成功，待管理员审核通过后将会展示在黑名单中',
          beforeClose: (action, done) => {
            this.$router.back();
            done();
          },
        });
      }).catch((err) => {
        console.error(err);
        this.$dialog.alert({
          message: err.message || '保存失败',
        });
      });
    },
    submit() {
      Promise.all([
        this.$refs.uForm.validate(),
        this.$refs.uFormReporter.validate(),
      ]).then((values) => {
        // console.log('校验成功------', values);
        this.save();
      }).catch((errors) => {
        // console.log('校验失败------');
        console.log(errors);
        this.$dialog.alert({
          message: '信息填写不完整，请参考页面红字提示',
        });
      });
    },
  },
});
</script>

<style>
.blacklistReport {
  min-height: 100vh;
  text-align: left;
  /* background-color: #ffffff; */
}
.blacklistReport-form {
  background-color: #ffffff;
  text-align: right;
}
.avatar-wrapper {
  background-color: #ffffff;
  text-align: right;
}
.custom-input {
  text-align: right;
  width: 100%;
  border: 1px solid #a7a9af!important;
  border-radius: 4px;
}
.custom-input::focus {
  border: 0;
}
.custom-button {

}
.blacklistReport >>> .u-upload{
  flex: inherit!important;
}
.van-field__control--custom {
  border: 0!important;
}
.action-modal {
  min-width: 260px;
}
/* .blacklistReport-form >>> .van-field__control.van-field__control--custom {
  border: none!important;
} */
</style>
